import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
import { ModalFrame } from "./ModalFrame.js";
import { DialogClose as DialogClose$1 } from "../vendor/@base-ui/react/dialog/close/DialogClose.js";
const Dialog = React.forwardRef(function Dialog2({ wide = false, ...rest }, ref) {
  return /* @__PURE__ */ jsx(ModalFrame, { ref, surfaceClass: cx("ev-dialog", wide && "ev-dialog--wide"), ...rest });
});
Dialog.displayName = "Dialog";
const variantClass = {
  primary: "ev-btn--primary",
  secondary: void 0,
  ghost: "ev-btn--ghost",
  danger: "ev-btn--danger"
};
const DialogClose = React.forwardRef(function DialogClose2({ variant = "secondary", className, type = "button", ...rest }, ref) {
  return /* @__PURE__ */ jsx(DialogClose$1, { ref, type, className: cx("ev-btn", variantClass[variant], className), ...rest });
});
DialogClose.displayName = "DialogClose";
export {
  Dialog,
  DialogClose
};
//# sourceMappingURL=Dialog.js.map
